export function randomString(
  length: number,
  charsType: "numbers" | "letters" | "both" = "both",
): string {
  let chars: string;

  switch (charsType) {
    case "numbers":
      chars = "0123456789";
      break;
    case "letters":
      chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
      break;
    case "both":
      chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      break;
    default:
      throw new Error("charsType должен быть 'numbers', 'letters' или 'both'");
  }

  let result = "";
  for (let i = 0; i < length; i += 1) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    result += chars[randomIndex];
  }

  return result;
}
